import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { TranslateModule } from '@ngx-translate/core';
import { AppService } from '../../core/services';
import { HeaderComponent } from '../header/header.component';

@Component({
  selector: 'bo-side-bar-container',
  templateUrl: './side-bar-container.component.html',
  standalone: true,
  imports: [CommonModule, MatSidenavModule, TranslateModule, HeaderComponent],
})
export class SideBarContainerComponent {
  private appService = inject(AppService);

  showSideBar = this.appService.showSideBar;

  hideSideBar() {
    this.appService.showSideBar.set(false);
  }
}
